module.exports = __webpack_public_path__ + "assets/fonts/iconfont.df2eff1f.woff2";